import classnames from 'classnames';
import React from 'react';

interface ButtonPropTypes {
    /** Additional classNames that can be supplied to the button element. */
    className?: string,
    /** Indicates that the button should be disabled. */
    disabled?: boolean,
    /** ID that is applied to the button, also used as the testID. */
    id?: string,
    /** The label of the button. */
    label: string,
    /** The value that should be given to the button's name property. */
    name?: string,
    /** The onClick handler of the button. */
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void,
    /** The type of the button(e.g. submit) */
    type?: ('button' | 'submit' | 'reset'),
    /** The value of the button. */
    value?: string,
    /** Whether or not the button should look like a primary button. */
    isPrimary?: boolean
}

/**
 * Generic Button component that renders a 'mets-command-button'.
 * 
 * @param {object} props 
 */
function Button(props: ButtonPropTypes) {

    const className = classnames('button', 'mets-command-button', { disabled: props.disabled, 'defaultBtn': props.isPrimary }, props.className)

    return (
        <button className={className}
                data-testid={props.id}
                disabled={props.disabled}
                id={props.id}
                onClick={props.onClick}
                name={props.name}
                type={props.type}
                value={props.value}>
                    {props.label}
        </button>
    );

}

Button.defaultProps = {
    disabled: false,
    isPrimary: false,
    type: 'button'
};

export default Button;